import type { AttachmentObjectKind } from './attachmentTypes';

/** Feed item `type` → attachment URL segment, for the maintenance events whose `attachments`
 * array a feed endpoint returns inline. */
const ATTACHMENT_KIND_BY_TYPE: Partial<Record<string, AttachmentObjectKind>> = {
    maintenance_observation: 'observation',
    maintenance_intervention: 'intervention',
    maintenance_improvement: 'improvement',
};

/**
 * Seeds the shared `getAttachments` cache (see `cardEvents/ducks`) from a feed response's inline
 * `attachments`, so the cards' count badge / media panel read from cache instead of firing a
 * redundant `GET /api/maintenance_module/<kind>/<id>/` per card on load. Upload/delete still
 * invalidate the `Attachment` tag, so the endpoint is only hit when the user actually manages
 * attachments. Shared by every feed-shaped endpoint that returns these items (`feed/ducks`'s
 * `getEvents` and `getFeedByUrl`) so they stay in sync.
 *
 * Deferred import of `cardEventsAPI` avoids a static import cycle (`cardEvents/ducks` already
 * imports `feed/ducks` for `invalidateFeedEvents`).
 */
export const seedAttachmentsFromFeedItems = async (
    dispatch: (action: any) => unknown,
    items: ReadonlyArray<{ type?: string; source_id?: number; attachments?: unknown }>,
): Promise<void> => {
    const { cardEventsAPI } = await import('../ducks');
    items.forEach((item) => {
        const objectKind = item.type ? ATTACHMENT_KIND_BY_TYPE[item.type] : undefined;
        if (!objectKind || item.source_id == null || !Array.isArray(item.attachments)) return;
        dispatch(
            cardEventsAPI.util.upsertQueryData(
                'getAttachments',
                { objectKind, objectId: String(item.source_id) },
                { attachments: item.attachments },
            ),
        );
    });
};
